/* consultation-cart.js — refuses checkout while a consultation-only line sits
   in the cart.

   The cart drawer and the cart page render a notice (`[data-consultation-notice]`)
   next to their checkout button whenever a line's product carries
   `custom.beratung_erforderlich`. The drawer re-renders its whole footer on
   every cart change, so its button can simply be `disabled` server-side. The
   cart page does not: cart.js re-renders only `.js-contents`, and the checkout
   block lives outside it — a `disabled` attribute set on page load would stick
   after the offending line is removed. So the page relies on CSS (`:has()` on
   the notice, see component-cart.css) for the look, and on this guard for the
   behaviour: a capture-phase submit listener on the document, which runs
   before Dawn's own handlers and also catches a keyboard-triggered submit that
   `pointer-events: none` would let through.

   Loaded by sections/main-cart-footer.liquid and snippets/cart-drawer.liquid.
*/

(() => {
  if (window.__consultationCartGuard) return;
  window.__consultationCartGuard = true;

  const CART_FORM_IDS = new Set(['cart', 'CartDrawer-Form']);

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !CART_FORM_IDS.has(form.id)) return;
      if (!document.querySelector('[data-consultation-notice]')) return;
      event.preventDefault();
      event.stopPropagation();
      const notice = document.querySelector('[data-consultation-notice]');
      if (notice && typeof notice.focus === 'function') notice.focus();
    },
    true
  );
})();
